export default __webpack_public_path__ + "static/6-65642ad4bbe216870d5742dfcb776260.png";